<template>
  <div class="dialog-warp">
    <div class="dialog-form" style="padding-left: 30px;padding-right: 20px;">
      <div class="g-thing-tit">
        <div class="flex-box" style="min-height: 40px;">
          <h4 style="flex: 1;">{{matterTypeInfo.matterName|empty}}</h4>
          <div class="thingstate">
            <span v-if="type === 0">待处理</span>
            <span v-if="type === 1">驳回待处理</span>
            <span v-if="type === 2">待确认</span>
            <span v-if="type === 3">已完成</span>
          </div>
        </div>
        <div class="flex-box" style="min-height: 40px;align-items: flex-start;">
          <p style="font-size: 12px;">事项类型：{{matterTypeInfo.matterTypeName|empty}}</p>
          <p style="margin: 0 20px;font-size: 12px;">发起人：{{matterTypeInfo.adminName|empty}}</p>
          <p style="flex: 1;font-size: 12px;">发起时间：{{matterTypeInfo.matterCreateTime|datetimeType('yyyy-MM-dd hh:mm')}}</p>
          <!--<p style="flex: 1;">联系电话：{{matterTypeInfo.companyContactTel|empty}}</p>-->
        </div>
      </div>
      <p class="g-contp" style="min-height: 40px;padding-top: 10px;text-indent:2em">
        {{matterTypeInfo.matterDes|empty}}</p>
        <div>
          事项附件：
          <p style="margin-left:70px;margin-top:5px;" v-for="(item,index) in matterFileList" :key="index">
            <el-link
              @click.stop="downFile(item.matterFileUrl,item.matterFileName)"
              type="primary">
              {{item.matterFileName}}
            </el-link>
          </p>
        </div>
    </div>
    <el-form v-if="type===1" class="dialog-form" ref="matterTypeInfo" :model="matterTypeInfo" size="mini"
             label-width="90px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="驳回时间：" prop="">
            <span>{{recordInfo.matterRejectRecordCreateTime|datetime}}</span>
          </el-form-item>
          <el-form-item label="驳回人：" prop="">
            <span>{{recordInfo.matterRejectRecordAdminName|empty}}</span>
          </el-form-item>
          <el-form-item label="驳回理由：" prop="">
            <span>{{recordInfo.matterRejectRecordReason|empty}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form class="dialog-form g-matter-form" ref="matterTypeInfo" :model="matterTypeInfo" size="mini"
             label-width="90px"
             label-position="top" disabled>
      <el-row style="padding: 20px;box-sizing: border-box;">
        <el-col :span="24" v-for="(matter,matterIndex) in labelList" :key="matterIndex">
          <el-form-item :label="matter.matterTypeFiledName+'：'" prop="">
            <el-input v-if="matter.matterTypeFiledType===1" v-model.trim="matter.matterCompanyFiledValue"
                      maxLength="30"></el-input>
            <el-input v-if="matter.matterTypeFiledType===2" v-model.trim="matter.matterCompanyFiledValue" type="textarea"
                      :rows="2" maxLength="500"></el-input>
            <el-radio-group v-if="matter.matterTypeFiledType===3" v-model="matter.radioValue">
              <div style="margin-top: -10px;">
                <div class="g-radio-box" v-for="(radio,radioIndex) in matter.radioList" :key="radioIndex">
                  <el-radio :label="radio.value">{{radio.label}}</el-radio>
                </div>
              </div>
            </el-radio-group>
            <el-checkbox-group v-if="matter.matterTypeFiledType===4" v-model="matter.checkboxValue">
              <div style="margin-top: -10px;">
                <div class="g-checkbox-box" v-for="(checkbox,checkboxIndex) in matter.checkboxList"
                     :key="checkboxIndex">
                  <el-checkbox :label="checkbox.value">{{checkbox.label}}</el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
            <ul v-if="matter.matterTypeFiledType===5">
              <li class="flex-box" style="width: 250px;padding: 5px 15px;" v-for="(file,fileIndex) in matter.fileList"
                  :key="fileIndex">
                <p class="ellipsis" style="flex: 1;color: #0066FF;" :title="file.matterCompanyFileName">
                  {{file.matterCompanyFileName|empty}}</p>
                <!--<a class="el-icon-download icon" style="color: #1396db;" v-if="file.matterCompanyFileUrl"-->
                <!--:href="file.matterCompanyFileUrl" :download="file.matterCompanyFileUrl"></a>-->
                <i class="el-icon-download download-icon" style="color: #1396db;"
                   @click="downloadFile(file,fileIndex)"></i>
              </li>
            </ul>
            <p v-if="matter.matterTypeFiledAnnotation" class="field-content">注：{{matter.matterTypeFiledAnnotation}}</p>
            <p v-if="matter.matterTypeFiledExample" class="field-content">例：{{matter.matterTypeFiledExample}}</p>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="labelListLoading||(!labelListLoading&&(!labelList||labelList.length===0))" class="text-center"
           style="margin-top: -40px;">
        <el-button v-if="labelListLoading" type="text" :loading="true">加载中</el-button>
        <span v-if="!labelListLoading&&(!labelList||labelList.length===0)">暂无数据</span>
      </div>
    </el-form>
    <div class="text-right">
      <el-button size="small" @click="close">&nbsp;&nbsp; 返回 &nbsp;&nbsp;</el-button>
    </div>
  </div>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        isEdit: false,
        confirmDialog: false,
        rejectDialog: false,
        labelListLoading: false,
        matterTypeInfo: {
          typeName: '',
          intoGeneralTable: 1,
        },
        labelList: [],
        updateLoading: false,
        submitLoading: false,
        rejectLoading: false,
        rejectInfo: {
          matterRejectReason: ''
        },
        contractFileHeader: {
          allSessionId: global.getSession('allSessionId'),
          adminAccount: global.getSession('adminAccount'),
          channelId: global.getSession('channelId'),
        },
        recordInfo: {},
        rules: {
          matterRejectReason: [
            {required: true, message: '请填写驳回理由', trigger: ['blur', 'change']},
          ],
        },
        radioList: [
          {
            label: '',
            value: 1,
          },
          {
            label: '',
            value: 2,
          },
        ],
        checkboxList: [
          {
            label: '',
            value: 1,
          },
          {
            label: '',
            value: 2,
          },
        ],
        fileList: [],
        matter: '',
        handleLoading: false,
        matterFileList:[]
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    props: ['type', 'matterId', 'matterCompanyId'],
    computed: {},
    methods: {
      reset() {
        this.rejectInfo.matterRejectReason = '';
        this.$refs['rejectInfo'].resetFields();
      },
      close(type) {
        if (type === 1) {
          this.$emit('init')
        }
        this.$emit('closeDialog')
      },
      init() {
        this.getMatterCompanyDetailDetail();
      },
      getMatterCompanyDetailDetail() {
        this.labelListLoading = true;
        getData.matterCompanyDetailDetail(this.matterId).then((res) => {
          this.labelListLoading = false;
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.message || res.data.msg
            });
            return
          }
          this.matterTypeInfo = res.data.data.matter ? res.data.data.matter : {};
          this.recordInfo = res.data.data.record ? res.data.data.record : {};
          let matterCompany = res.data.data.matterCompany;
          let filedList = matterCompany.matterCompanyValue ? global.strParse(matterCompany.matterCompanyValue) : [];
          filedList = filedList ? filedList : [];
          filedList.forEach((item) => {
            delete item.matterTypeFiledCreateTime;
            !item.matterCompanyFiledValue ? item.matterCompanyFiledValue = '' : '';
            if (item.matterTypeFiledType === 3 && item.matterTypeFiledValue) {
              let obj = global.strParse(item.matterTypeFiledValue);
              obj = obj ? obj : {};
              item.radioValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue : '';
              item.radioList = obj.radioList ? obj.radioList : [];
              item.matterTypeFiledValue = '';
            }
            else if (item.matterTypeFiledType === 4 && item.matterTypeFiledValue) {
              let obj = global.strParse(item.matterTypeFiledValue);
              obj = obj ? obj : {};
              item.checkboxValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue.split(',') : [];
              item.checkboxList = obj.checkboxList ? obj.checkboxList : [];
              item.matterTypeFiledValue = '';
            } else if (item.matterTypeFiledType === 5) {
              item.fileList = [];
              item.uploadFileList = [];
              if (item.matterCompanyFiledValue) {
                let obj = global.strParse(item.matterCompanyFiledValue);
                item.fileList = obj ? obj : [];
              }
            }
          });
          this.labelList = filedList;
          this.matterFileList=res.data.data.matterFileList;
        }).catch(_ => {
          this.labelListLoading = false;
        })
      },
      downloadFile(row, index) {
        if (!row.matterCompanyFileId) {
          this.$message({
            type: 'warning',
            message: '下载地址不存在！'
          });
          return
        }
        window.location.href = `company/matterCompany/downloadFile?matterCompanyFileId=${row.matterCompanyFileId}`
      },
      delFile(arr, arr2, index) {
        this.$confirm('确认删除该文件？').then(_ => {
          arr.splice(index, 1);
          this.$message.success('删除成功！');
          arr2.splice(index, 1);
        }).catch(_ => {
        })
      },
      beforeUpdate(file, fileList, row, index) {
        this.matter = row;
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 10MB!');
          return false
        }
        if (this.type === 1) {
          const is5Length = row.fileList.length + row.uploadFileList.length < 5;
          if (!is5Length) {
            this.$message.error('当前限制选择 5 个文件');
            return false
          }
        }
        return true;
      },
      remove(file, fileList) {
        console.log(file, fileList);
        console.log(file, fileList, 'resmove');
        // this.fileList = fileList;
        if (this.matter) {
          typeof this.matter.uploadFileList === 'object' ? this.matter.uploadFileList = fileList : '';
        } else {
          console.log('data add file fail')
        }
      },
      success(response, file, fileList) {
        if (response.code == 'success') {
          this.$message({
            type: 'success',
            message: '上传文件成功！'
          });
          console.log(response);
          if (this.matter) {
            typeof this.matter.uploadFileList === 'object' ? this.matter.uploadFileList = fileList : '';
            typeof this.matter.fileList === 'object' ? this.matter.fileList.push({
              matterCompanyFileName: response.data.fileName,
              matterCompanyFileUrl: response.data.fileUrl,
            }) : '';
          }
        }
      },
      handleExceed(files, fileList, row, index) {
        if (this.type === 1) {
          this.$message.warning(`当前限制选择 5  个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + (row ? (row.fileList ? row.fileList.length : 0) : 0)} 个文件`)
        } else {
          this.$message.warning(`当前限制选择 5  个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        }
      },
      error(err, file, fileList) {
        this.$message({
          type: 'error',
          message: '上传文件失败！'
        });
        console.log(err, file, fileList)
      },
      checkData() {
        let isOk = [];
        this.labelList.forEach((item, index) => {
          if (item.matterTypeFiledType === 3) {
            if (!item.radioValue) {
              isOk.push(3)
            } else {
              isOk.push(1)
            }
          }
          else if (item.matterTypeFiledType === 4) {
            if (!item.checkboxValue || item.checkboxValue.length === 0) {
              isOk.push(4)
            } else {
              isOk.push(1)
            }
          }
          else if (item.matterTypeFiledType === 5) {
            if (!item.fileList || item.fileList.length === 0) {
              isOk.push(5)
            } else {
              isOk.push(1)
            }
          } else {
            if (!item.matterCompanyFiledValue) {
              isOk.push(0)
            } else {
              isOk.push(1)
            }
          }
        });
        if (isOk.indexOf(0) !== -1) {
          this.$message.warning(`请填写完整短文本或者长文本数据后在提交！`);
          return false
        } else if (isOk.indexOf(3) !== -1) {
          this.$message.warning(`请选择单选项数据后在提交！`);
          return false
        } else if (isOk.indexOf(4) !== -1) {
          this.$message.warning(`请选择多选项数据后在提交！`);
          return false
        } else if (isOk.indexOf(5) !== -1) {
          this.$message.warning(`请上传文件数据后在提交！`);
          return false
        }
        return true;
      },
      handle() {
        if (!this.checkData()) {
          return
        }
        let arr = [];
        arr = [...this.labelList].map((item) => {
          if (item.matterTypeFiledType === 3) {
            item.matterCompanyFiledValue = item.radioValue;
          }
          else if (item.matterTypeFiledType === 4) {
            item.matterCompanyFiledValue = item.checkboxValue.join(',');
          }
          else if (item.matterTypeFiledType === 5) {
            delete  item.uploadFileList
          }
          return item
        });
        const data = {
          matterCompanyId: this.matterCompanyId,
          filedList: arr,
        };
        console.log(data);
        this.handleLoading = true;
        this.type === 1 ? this.handleMatterCompany(data) : this.editMatterCompany(data);
      },
      handleMatterCompany(data) {
        getData.handleMatterCompany(data).then((res) => {
          this.handleLoading = false;
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.message || res.data.msg
            });
            return
          }
          this.$message.success('操作成功！');
          this.close(1)
        }).catch(_ => {
          this.handleLoading = false;
          this.$message.warning('操作失败！')
        })
      },
      editMatterCompany(data) {
        getData.editMatterCompany(data).then((res) => {
          this.handleLoading = false;
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.message || res.data.msg
            });
            return
          }
          this.$message.success('操作成功！');
          this.close(1)
        }).catch(_ => {
          this.handleLoading = false;
          this.$message.warning('操作失败！')
        })
      },
      //下载
      downFile(FileUrl, FileName) {
        //参数名随意
        window.open(
          "/company/download/downloadWorkflowFileUseName?fileUrl=" +
            FileUrl +
            "&fileName=" +
            FileName
        );
      },
    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .label-btn {
    padding-left: 10px;
    padding-right: 10px;
  }

  .close-icon {
    position: absolute;
    top: -6px;
    right: -6px;
    font-size: 16px;
    color: #ff0000;
    cursor: pointer;
  }

  .g-t-btn {
    width: 100%;
    margin: 3px auto 12px;
    text-align: center;
    display: block;
    box-sizing: border-box;
    background: #56bdff;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
  }

  .field-content {
    font-size: 14px;
    color: #999;
  }

  .download-icon {
    margin-left: 10px;
    font-size: 20px;
    font-weight: 700;
    color: #1296db;
    cursor: pointer;
  }

  .thingstate {
    margin-right: -20px;
    @include wh(80px, 30px);
    background: #169bd5;
    border-radius: 15px 0 0 15px;
    text-align: center;
    line-height: 30px;
    @include sc(13px, #fff)
  }

  .icon {
    font-size: 20px;
    font-weight: 600;
    margin-left: 10px;
    cursor: pointer;
  }

  .g-radio-box, .g-checkbox-box {
    display: inline-block;
    margin-top: 10px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form-detail.vue